<template>

    <q-banner dense inline-actions class="text-black bg-orange">
        Information is limited due to the lack of candidates responding.
    </q-banner>

    <q-scroll-area style="height: calc(100vh - 380px);" class="text-subtitle1">
        <q-list v-if="global.candidate!=null">

            <q-item>
                <q-item-section>
                    <q-item-label>Gas Tax</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.gasTax==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.gasTax==2" class="text-red">Does not Supports.</div>

                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Against All Mandates</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.againstALLMandates==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.againstALLMandates==2" class="text-red">Does not Supports.</div>

                    <div v-else class="text-grey">No Information</div>
                    <!-- <q-icon v-else size="2em" name="question_mark" color="orange" /> -->
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Against Abortion</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.antiAbortion==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.antiAbortion==2" class="text-red">Does not Supports.</div>

                    <div v-else class="text-grey">No Information</div>
                    <!-- <q-icon v-else size="2em" name="question_mark" color="orange" /> -->
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Constitutional Carry</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.constitutionalCarry==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.constitutionalCarry==2" class="text-red">Does not Supports.</div>
                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Election Integrity</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.electionIntegrity==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.electionIntegrity==2" class="text-red">Does not Supports.</div>

                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Health Freedom</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.healthFreedom==1" class="text-green">Supports.</div>
                    <div v-else-if="global.candidate.healthFreedom==2" class="text-red">Does not Supports.</div>

                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Repeal State Health Officers Powers</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.repealStateHealthPowers==1" class="text-green">Supports.
                    </div>
                    <div v-else-if="global.candidate.repealStateHealthPowers==2" class="text-red">Does not Supports.
                    </div>

                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

            <q-item>
                <q-item-section>
                    <q-item-label>Against Illegals Being Imported Into Alabama</q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <div v-if="global.candidate.againstIllegals==1" class="text-green">Supports.
                    </div>
                    <div v-else-if="global.candidate.againstIllegals==2" class="text-red">Does not Supports.</div>


                    <div v-else class="text-grey">No Information</div>
                </q-item-section>

            </q-item>

            <q-separator spaced inset />

        </q-list>

    </q-scroll-area>
</template>


<style>
</style>

<script>

    import { global } from './Global.js';

    export default {
        name: 'Voting',
        data() {
            return {
                candidate: global.candidate,

                global
            }

        }
    }
</script>